/**
 * Created by Alican Köker on 2019-01-21.
 */
import {
    IStillImageBackgroundConfig,
    IStillImageBackgroundImagesConfig
} from "@nolimitcity/slot-game/bin/game/background/StillImageBackground";
import { GameResources } from "@nolimitcity/slot-game/bin/core/resource/GameResources";
import { IGameModeChangedData } from "@nolimitcity/slot-game/bin/core/gamemode/GameMode";
import { EdisonGameConfig } from "../EdisonGameConfig";
import { Background } from "@nolimitcity/slot-game/bin/core/background/Background";
import { IResizeData, StageManager } from "@nolimitcity/slot-game/bin/core/stage/StageManager";
import { EdisonGameMode } from "../gameMode/EdisonGameMode";
import { Orientation } from "@nolimitcity/slot-game/bin/core/stage/Orientation";
import { ServerEvent } from "@nolimitcity/slot-game/bin/core/server/event/ServerEvent";
import { GameEvent } from "@nolimitcity/slot-game/bin/core/event/GameEvent";
import { EventHandler } from "@nolimitcity/slot-game/bin/core/event/EventHandler";
import { EdisonParsedGameData } from "../server/data/EdisonParsedGameData";
import { EdisonGameAssets } from "../EdisonGameAssets";
import { ScalableLayer } from "@nolimitcity/slot-game/bin/core/stage/ScalableLayer";
import { TweenLite } from "gsap";
import { EdisonParsedInitData } from "../server/data/EdisonParsedInitData";
import { EdisonIndividualWPView } from "../winpresentation/individual/EdisonIndividualWPView";

export interface IEdisonStillImageBackgroundImagesConfig extends IStillImageBackgroundImagesConfig {
    readonly NORMAL:{
        image:string;
        offset?:PIXI.Point;
    };
    readonly FREESPIN:{
        image:string;
        offset?:PIXI.Point;
    };
    readonly STACKED_RESPIN:{
        image:string;
        offset?:PIXI.Point;
    };
}

export interface IEdisonStillImageBackgroundConfig extends IStillImageBackgroundConfig {
    readonly backgroundImages:IEdisonStillImageBackgroundImagesConfig;
    readonly stretch:boolean;
}

export class EdisonBackground extends Background {

    private _backgroundSpineAnim:PIXI.spine.Spine;
    private _isRestore:boolean = false;
    private _initResized:boolean = false;
    private _initAnimations:boolean = false;
    private _initBackgroundSpine:boolean = false;
    private _reelBg:PIXI.Sprite;
    private _reelBGLayer:ScalableLayer;
    private _reelBGPortraitTopPadding:number = -260;
    private _reelBgLeftPadding:number = 0;
    private _nextMode:EdisonGameMode = EdisonGameMode.NORMAL;
    private _dimmer:PIXI.Graphics;
    private _bgW:number = 1280;
    private _bgH:number = 720;
    private _animName:string = "IdleBasegame";
    private _aspectRatio:number = 1;
    protected _backgroundSprite:PIXI.Sprite;
    private _spineLayer:ScalableLayer;


    private _orientation:string;

    protected readonly _stretch:boolean;
    protected readonly _backgroundImages:IStillImageBackgroundImagesConfig;
    constructor(config:IEdisonStillImageBackgroundConfig) {
        super(config);

        this._reelBGLayer = StageManager.getLayer(EdisonGameConfig.instance.LAYERS.REEL_BACKGROUND.name);
        this._spineLayer = StageManager.getLayer(EdisonGameConfig.instance.LAYERS.BACKGROUND.name);

        this._currentMode = EdisonGameMode.NORMAL;
        this._orientation = Orientation.LANDSCAPE;

        this._backgroundImages = config.backgroundImages;
        this._stretch = config.stretch;

        this.addEventListeners();
    }


    protected onChangeBackground(data:IGameModeChangedData):boolean {
        return super.onChangeBackground(data)
    }

    protected onGameDataParsed(data:EdisonParsedGameData):void {
        //this.currentMode = data.mode;
        this._nextMode = data.nextMode;
        this._isRestore = false;
    }


    protected onInitDataParsed(data:EdisonParsedInitData):void {
        //this.currentMode = data.mode;
        this._nextMode = data.nextMode;
        this._isRestore = data.isRestoreState;
    }

    protected addEventListeners():void {
        EventHandler.addEventListener(this, ServerEvent.GAME_DATA_PARSED, (event:GameEvent) => this.onGameDataParsed(event.params[0]));
        EventHandler.addEventListener(this, ServerEvent.INIT_DATA_PARSED, (event:GameEvent) => this.onInitDataParsed(event.params[0]));
        EventHandler.addEventListener(this, EdisonIndividualWPView.SET_MODE, (event:GameEvent) => this.currentMode = event.params[0]);
    }

    public handleSpineBackgroundResize(orientation:string):void {

        if(orientation === Orientation.LANDSCAPE) {
            this._backgroundSprite.x = 630;
            this._backgroundSprite.y = 260;
            this._backgroundSprite.anchor.set(0.5, 0.5);
            this._backgroundSprite.scale.set(0.7, 0.7);
            //this._spineLayer.width = GameConfig.instance.GAME_WIDTH;
        }
        else {
            this._backgroundSprite.x = 630;
            this._backgroundSprite.y = 340;
            this._backgroundSprite.scale.set(1.4, 1.4);
        }

        /*const xRatio:number = this._orientation === Orientation.LANDSCAPE ? this._aspectRatio > 1.4 ? this._aspectRatio < 2 ? 1 : 1.3 : .8 :
            this._aspectRatio > .47 ? this._aspectRatio < .7 ? 1 : 1.3 : 1.1;
        const yRatio:number = this._orientation === Orientation.LANDSCAPE ? this._aspectRatio > 1.4 ? this._aspectRatio < 2 ? 1.3 : 1.1 : .5 :
            this._aspectRatio > .47 ? this._aspectRatio < .7 ? 1.3 : 1.1 : 1.3;

        if(this._stretch) {
            //this._backgroundSprite.width = EdisonGameConfig.instance.GAME_WIDTH;
            //this._backgroundSprite.height = EdisonGameConfig.instance.GAME_HEIGHT;
            //this._backgroundSprite.scale.set(xRatio, yRatio);
        } else {
            //this._backgroundSprite.scale.set(xRatio, yRatio);
        }*/

        //if(this._initResized) {
            //this._backgroundSprite.scale.set(xRatio, yRatio)
        //}

    }

    protected onResize?(resizeData:IResizeData):void {

        const screenWidth = resizeData.width / this._layer.scale.x;
        const screenHeight = resizeData.height / this._layer.scale.y;
        this._aspectRatio = screenWidth / screenHeight;
        this._reelBGPortraitTopPadding = resizeData.orientation === Orientation.LANDSCAPE ? 10 : EdisonGameConfig.instance.REEL_AREA_PORTRAIT_TOP_PADDING_PORTRAIT;

        this._reelBgLeftPadding = resizeData.orientation === Orientation.PORTRAIT ?
            EdisonGameConfig.instance.REEL_AREA_PORTRAIT_LEFT_PADDING :
            EdisonGameConfig.instance.REEL_AREA_LANDSCAPE_LEFT_PADDING;

        //this.setBackgroundAnimations(resizeData.orientation, this._currentMode);

        if(this._orientation !== resizeData.orientation || this._isRestore || !this._initResized) {
            this._orientation = resizeData.orientation;
            this.handleSpineBackgroundResize(this._orientation);
            this._reelBg.position.set(this._reelBgLeftPadding, this._reelBGPortraitTopPadding);
            this._initResized = true;
        }

        this._bgW = 2400;
        this._bgH = 2400;

        this._dimmer.clear();
        this._dimmer.beginFill(0x000002);
        this._dimmer.drawRect(0, 0, this._bgW, this._bgH);
        this._dimmer.position.set(-this._dimmer.width / 2, -this._dimmer.height / 2);

        this.changeAnimName();

        this._backgroundSpineAnim.state.setAnimation(0, this._animName, true);
    }

    protected initAnimations():void {
        super.initAnimations();

        this._backgroundSprite = new PIXI.Sprite();

        this.addChild(this._backgroundSprite);

        this._backgroundSpineAnim = new PIXI.spine.Spine(GameResources.getSpineAsset("backgroundSpine"));

        this._layer.addChild(this);

        this._backgroundSprite.addChild(this._backgroundSpineAnim);

        this._reelBg = new PIXI.Sprite(GameResources.getTextures(EdisonGameAssets.REEL_FRAME)[0]);

        this.changeReelBackground(this._currentMode.toLowerCase());

        this._reelBGLayer.addChild(this._reelBg);

        this._initAnimations = true;

        this._dimmer = new PIXI.Graphics();
        this._backgroundSprite.addChild(this._dimmer);
        this._dimmer.alpha = 0;

        this._backgroundSpineAnim.stateData.setMix("IdleFreespinPortrait", "IdleBasegamePortrait", 1);
        this._backgroundSpineAnim.stateData.setMix("IdleReSpinPortrait", "IdleBasegamePortrait", 1);
        this._backgroundSpineAnim.stateData.setMix("IdleBasegamePortrait", "IdleFreespinPortrait", 1);
        this._backgroundSpineAnim.stateData.setMix("IdleBasegamePortrait", "IdleReSpinPortrait", 1);
    }

    public set currentMode(mode:string) {
        if(this._initAnimations)
            this.changeReelBackground(mode.toLowerCase());

        if(this._currentMode === mode && this._initBackgroundSpine)
            return;

        this._currentMode = mode;


        this._reelBGPortraitTopPadding = this._orientation === Orientation.PORTRAIT ? -260 : 0;

        if(!this._backgroundSpineAnim)
            return;

        this._initBackgroundSpine = true;

        this.changeAnimName();

        let entry:PIXI.spine.core.TrackEntry = this._backgroundSpineAnim.state.setAnimation(0, this._animName, true);
        entry.mixDuration = 1;
    }

    private changeAnimName():void {
        if(this._currentMode === EdisonGameMode.FREESPIN) {
            this._animName = this._orientation === Orientation.LANDSCAPE ? "IdleFreespinLandscape" : "IdleFreespinPortrait";
            this._backgroundSpineAnim.state.setAnimation(0, this._animName, true);
        } else if(this._currentMode === EdisonGameMode.STACKED_RESPIN) {
            this._animName = this._orientation === Orientation.LANDSCAPE ? "IdleReBasegame" : "IdleReSpinPortrait";
            this._backgroundSpineAnim.state.setAnimation(0, this._animName, true);
        } else {
            this._animName = this._orientation === Orientation.LANDSCAPE ? "IdleBasegame" : "IdleBasegamePortrait";
        }
    }

    public dimBackground(dimmed:boolean):void {
        TweenLite.to(this._dimmer, .3, {alpha : dimmed ? .3 : 0});
    }

    public changeReelBackground(bg:string):void {
        if(bg === "freespin"){
            this._reelBg.texture = GameResources.getTextures(EdisonGameAssets.REEL_FRAME_DARK)[0];
        } else if(bg === "freespinWP") {
            this._reelBg.texture = GameResources.getTextures(EdisonGameAssets.REEL_FRAME_DARK_WP)[0];
        } else if(bg === "winpresentation"){
            this._reelBg.texture = GameResources.getTextures(EdisonGameAssets.REEL_FRAME_WP)[0];
        } else{
            this._reelBg.texture = GameResources.getTextures(EdisonGameAssets.REEL_FRAME)[0];
        }
    }

}